module.exports = __webpack_public_path__ + "static/media/Lese.53256c6a.PNG";